let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("h5vux")).then(() => parcelRequire('kyT0s'));